import { HotelResultsState } from './hotelResultsTypes';

export const hotelResultsInitialState: HotelResultsState = { hotelSearchResults: null };
